<script setup lang="ts">
import crystalBallXs from "~/assets/icons/crystalball/crystalball-xs.svg"
import findXs from "~/assets/icons/find/find-xs.svg"

defineProps({
  file: null
})

const { moveToArchive, permanentlyDelete } = useContextMenu()
const { downloadFiles } = useJobs()
const { peekFiles } = usePeek()
const { addFilesToSidebar, removeFilesFromSidebar, sidebarFiles } = useSidebar()
const { navigateToFile, navigateToFolder, openFolderInNewTab, openFileInNewTab } = useNavigation()
const { openInstantMenuWithFileIn, openInstantMenuWithFileNear } = useInstantMenu()
const { onFilesCut, onFilesCopied } = useClipboard()
const { askAgentAboutAFile } = useAgent()
</script>

<template>
  <div>
    <menu-section>
      <dropdown-item
        v-if="!file.isFolder()"
        shortcut="␣"
        @click="peekFiles([file], 'collection-view')"
      >
        Quick View
      </dropdown-item>
      <dropdown-item
        v-if="file.isFolder()"
        shortcut="↵"
        @click="navigateToFolder(file)"
      >
        Open
      </dropdown-item>
      <dropdown-item
        v-else
        shortcut="↵"
        @click="navigateToFile(file)"
      >
        Open
      </dropdown-item>
      <dropdown-item
        v-if="file.isFolder()"
        shortcut="⌘↵"
        @click="openFolderInNewTab(file)"
      >
        Open in new tab
      </dropdown-item>
      <dropdown-item
        v-else
        shortcut="⌘↵"
        @click="openFileInNewTab(file)"
      >
        Open in new tab
      </dropdown-item>
      <menu-separator />
      <dropdown-item
        shortcut="⌘X"
        @click="onFilesCut({ [file.fileId]: file })"
      >
        Cut
      </dropdown-item>
      <dropdown-item
        shortcut="⌘C"
        @click="onFilesCopied({ [file.fileId]: file })"
      >
        Copy
      </dropdown-item>
      <!-- <dropdown-item shortcut="⌘V">
        Paste
      </dropdown-item> -->
      <menu-separator />
      <dropdown-item
        v-if="!!sidebarFiles[file.fileId]"
        @click="removeFilesFromSidebar({ [file.fileId]: file })"
      >
        Unpin from sidebar
      </dropdown-item>
      <dropdown-item
        v-else
        @click="addFilesToSidebar({ [file.fileId]: file })"
      >
        Pin to sidebar
      </dropdown-item>
      <menu-separator />
      <dropdown-item @click="askAgentAboutAFile(file)">
        <div class="icon-item">
          <div class="icon">
            <crystal-ball-xs />
          </div>
          <div>Ask Poly...</div>
        </div>
      </dropdown-item>
      <dropdown-item v-if="file.isFolder()" @click="openInstantMenuWithFileIn(file)">
        <div class="icon-item">
          <div class="icon">
            <find-xs />
          </div>
          <div>Search within...</div>
        </div>
      </dropdown-item>
      <dropdown-item v-else-if="file.supportsSimilaritySearch()" @click="openInstantMenuWithFileNear(file)">
        <div class="icon-item">
          <div class="icon">
            <find-xs />
          </div>
          <div>Find similar files...</div>
        </div>
      </dropdown-item>
      <menu-separator />
      <dropdown-item @click="downloadFiles({ [file.fileId]: file })">
        Download
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-item
        v-if="file.getArchiveFolderFromPath()"
        @click="permanentlyDelete({ [file.fileId]: file })"
      >
        <span class="delete-warning">Permanently Delete...</span>
      </dropdown-item>
      <dropdown-item
        v-else
        shortcut="⌫"
        @click="moveToArchive({ [file.fileId]: file })"
      >
        Move to Archive
      </dropdown-item>
    </menu-section>
    <menu-separator />
    <menu-section>
      <dropdown-file-status :file />
    </menu-section>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.delete-warning
  @apply font-medium text-$global-red-primary

.icon-item
  @apply inline-flex gap-1 inline-center
  .icon
    @apply w-4 h-4 flex items-center justify-center
</style>
